import React, { useState, useEffect } from 'react';
const { useNavigate } = require('react-router-dom');
// import axios from 'axios';

export default function LoginProtoPage() {
    const navigate = useNavigate();
    const handleSignup = () => {
        navigate('/signup')
    };
    function handleLogin() {
        navigate('/login');
    }

    return (
        <main className='LoginProtoPage' id='LoginProtoPage-id'>
            <div className="Line-LoginProtoPage">
                Create an Account
            </div>
            <div className="button-LoginProtoPage">
                <div className="login-LoginProtoPage" onClick={handleLogin}>
                    Login
                </div>
                <div className="signup-LoginProtoPage" onClick={handleSignup}>
                    Signup
                </div>
            </div>
        </main>
    );
}